
import QRCode from "react-qr-code";
import { useRef, useState } from "react";

export default function Qr_Codes({ heading, url }) {
  const qrRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);

  const downloadQRCode = () => {
    const qrContainer = qrRef.current;
    const svgElement = qrContainer.querySelector("svg");
    if (svgElement) {
      // Get the computed styles to account for CSS padding (20px from App.css)
      const padding = 20; // Fixed padding value from CSS

      // Get SVG dimensions
      const svgRect = svgElement.getBoundingClientRect();

      // Calculate total dimensions including padding
      const totalWidth = svgRect.width + (padding * 2);
      const totalHeight = svgRect.height + (padding * 2);

      // Create canvas with proper dimensions including padding
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = totalWidth;
      canvas.height = totalHeight;

      // Fill canvas with white background
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, totalWidth, totalHeight);

      // Convert SVG to data URL
      const svgData = new XMLSerializer().serializeToString(svgElement);
      const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
      const svgUrl = URL.createObjectURL(svgBlob);

      // Load SVG as image and draw on canvas with proper padding
      const img = new Image();
      img.onload = function() {
        // Draw the QR code centered with padding
        ctx.drawImage(img, padding, padding, svgRect.width, svgRect.height);
        URL.revokeObjectURL(svgUrl);

        // Convert canvas to PNG
        const pngUrl = canvas.toDataURL("image/png");

        // Create download link
        const downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;

        // Use the heading as filename, sanitize it for file system
        const fileName = heading
          ? `${heading.replace(/[^a-zA-Z0-9]/g, '_')}.png`
          : "qr_code.png";

        downloadLink.download = fileName;

        // Trigger download (this will open file explorer dialog)
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        // Show popup
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 2000);
      };

      img.src = svgUrl;
    }
  };

  return (
    <>
      <style>{`
        @keyframes slideInBounce {
          0% {
            opacity: 0;
            transform: translateX(20px) scale(0.8);
          }
          50% {
            transform: translateX(-5px) scale(1.05);
          }
          100% {
            opacity: 1;
            transform: translateX(0) scale(1);
          }
        }
      `}</style>
      <div
        className="user-card"
        onClick={downloadQRCode}
        style={{
          backgroundColor: '#2a2d35',
          border: '1px solid #444',
          borderRadius: '12px',
          padding: '20px',
          cursor: 'pointer',
          transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
          overflow: 'visible',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#33363f';
          e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
          e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.5), 0 0 20px rgba(24, 119, 24, 0.4)';
          e.currentTarget.style.border = '1px solid #187718';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#2a2d35';
          e.currentTarget.style.transform = 'translateY(0) scale(1)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
          e.currentTarget.style.border = '1px solid #444';
        }}
      >
        <div style={{ marginBottom: '15px', width: '100%' }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#fff',
            margin: '0 0 15px 0',
            borderBottom: '2px solid #187718',
            paddingBottom: '8px',
            textAlign: 'center'
          }}>
            {heading}
          </h3>
        </div>

        <div ref={qrRef} style={{
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '8px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <QRCode value={url} size={200} />
        </div>

        {showPopup && (
          <div style={{
            position: 'absolute',
            bottom: '-50px',
            left: '0',
            right: '0',
            margin: '0 auto',
            background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: '600',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            animation: 'slideInBounce 0.4s ease-out',
            border: '1px solid rgba(255,255,255,0.2)',
            backdropFilter: 'blur(10px)',
            letterSpacing: '0.3px',
            whiteSpace: 'nowrap',
            width: '200px',
            justifyContent: 'center'
          }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              width="16"
              height="16"
              fill="currentColor"
              style={{ flexShrink: 0 }}
            >
              <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
            </svg>
            <span>{heading} QR downloaded</span>
          </div>
        )}
      </div>
    </>
  );
}
